import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { fetchMenuItemStart } from '../../redux/menu-item/menuItem.action'
import { setPageName, setStations, setStation, setStationFetching, checkLeadTimeSuccess, ToggleStationList, ToggleEmptyCartPop, setStationsDetailAllStart, setBoardingDate, setTrainNo, setBoardingStation, setPnr, setHomeTab, setUrlData } from '../../redux/cart/cart.action'
import { selectPageName, selectStationFetching, selectStationToggle, selectVersion } from '../../redux/cart/cart.selector';
import { selectMenuLoading } from '../../redux/menu-item/menu-item.selector';
import { selectMainBanner, selectMainBannerLoading } from '../../redux/main-banner/main-banner.selector';
import { selectSmallBanner, selectSmallBannerLoading } from '../../redux/small-banner/small-banner.selector';
import { mainBannerSelectionStart } from '../../redux/main-banner/main-banner.action';
import { smallBannerSelectionStart } from '../../redux/small-banner/small-banner.action';
import { menuCategorySelectionStart } from '../../redux/menu-category/menu-category.action';
import { selectMenuCategoryLoading } from '../../redux/menu-category/menu-category.selector';

import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import MainBanner from '../../components/main-banner/main-banner.component';
import SmallBanner from '../../components/small-banner/small-banner.component';
import MenuCollection from '../../components/menu-collections/menu-collections.component';
import Sticky from '../../components/sticky/sticky.component';
import OverLay from '../../components/overlay/overlay.component';
import Shimmer from '../../components/shimmer/shimmer.component';
import HomeJourney from '../../components/home-journey-details/home-journey-details.components';
import Emptycart from '../../components/empty-cart/empty-cart.component';
import Faq from '../faqs/faq.component';
import './homepage.style.css';

class homePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bannerImgReady: false,
            bannerSmallImgReady: false,
        }
        const { menuItem, setPage, setStations, setStation, mainBanner, smallBanner, menucategory, setLeadTime, ToggleEmptyPop } = this.props;
        this.props.setUrlData(this.props.location.search);
        mainBanner();
        smallBanner();
        menuItem();
        setPage('Journey Details');
        setStations([]);
        setStation([]);
        setLeadTime([]);
        menucategory();
        ToggleEmptyPop('');

    }

    async componentDidMount() {
        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.train_num && parsed.train_num != 'null') {
            this.props.setDate('')
        }
        if (parsed.train_num && parsed.train_num != 'null') {
            this.props.setTrainNo(parsed.train_num)
        }
        if (parsed.stn && parsed.stn != 'null') {
            this.props.setBoardingStation(parsed.stn)
        }
        if (parsed.doj && parsed.doj != 'null') {
            this.props.setDate(parsed.doj)
        }
        if (parsed.train_num && parsed.train_num != 'null' && parsed.stn && parsed.stn != 'null' && parsed.doj && parsed.doj != 'null') {
            this.props.setTab('TRAIN')
            this.props.setStationAll();
        } if (parsed.pnr && parsed.pnr != 'null') {
            this.props.setPnr(parsed.pnr);
            this.props.setTab('PNR');
            await this.props.setStationAll();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.pathname) {
            // window.gtag("config", "AW-758297155", {
            //     page_title: "Home V3",
            //     page_path: this.props.location.pathname,
            // })
        }
        if (this.props.pagename === 'Journey Details') {
            document.body.classList.remove('overlay-hide');
        }
        if (this.props.staionToggle === true) {
            this.props.setStationToggle();
        }
        if (this.props.bannerImg !== null && this.state.bannerImgReady === false) {
            const bannerCount = this.props.bannerImg.length;
            let n = 0;
            this.props.bannerImg.forEach((picture) => {
                const img = new Image();
                img.src = picture.image_url;
                n = n + 1;
                if (n === bannerCount) {
                    img.onload = () => {
                        this.setState({ bannerImgReady: true });
                    }
                }
            });

        }

        if (this.props.smallBannerImg !== null && this.state.bannerSmallImgReady === false) {
            const bannerSmallCount = this.props.smallBannerImg.length;
            let n = 0;
            this.props.smallBannerImg.forEach((picture) => {
                const img = new Image();
                img.src = picture.image_url;
                n = n + 1;
                if (n === bannerSmallCount) {
                    img.onload = () => {
                        this.setState({ bannerSmallImgReady: true });
                    }
                }
            });
        }
    }


    render() {

        const { bannerImgReady, bannerSmallImgReady } = this.state;
        const { pagename, menuLoading, mainBannerLoading, smallBannerLoading, menuCategoryLoading, version, bannerImg, smallBannerImg } = this.props;
        if (menuLoading === false && mainBannerLoading === false && smallBannerLoading === false && menuCategoryLoading === false && (bannerImg === null || bannerImgReady === true) && version === '') {
            return (
                <div className="homepage-container">
                    <OverLay page={pagename} />
                    <Emptycart />
                    <Header />
                    <HomeJourney />
                    <MainBanner />
                    <MenuCollection />
                    <Sticky />
                    <SmallBanner />
                    <br /><Faq />
                    <Footer />
                </div>
            )
        } else if (menuLoading === false && mainBannerLoading === false && smallBannerLoading === false && menuCategoryLoading === false && (bannerImg === null || bannerImgReady === true) && version === '3') {
            return (
                <div className="homepage-container">
                    <OverLay page={pagename} />
                    <Emptycart />
                    <Header />
                    <HomeJourney />
                    <Sticky />
                    <br /><Faq />
                    <Footer />
                </div>
            )
        } else {
            return (
                <div>
                    <Shimmer />
                </div>
            )
        }
    }
}

const mapStateToProps = createStructuredSelector({
    pagename: selectPageName,
    menuLoading: selectMenuLoading,
    mainBannerLoading: selectMainBannerLoading,
    smallBannerLoading: selectSmallBannerLoading,
    menuCategoryLoading: selectMenuCategoryLoading,
    isStationFetching: selectStationFetching,
    bannerImg: selectMainBanner,
    smallBannerImg: selectSmallBanner,
    staionToggle: selectStationToggle,
    version: selectVersion,
})

const mapDispatchToProps = dispatch => ({
    menuItem: () => dispatch(fetchMenuItemStart()),
    setPage: page => dispatch(setPageName(page)),
    setStations: stationList => dispatch(setStations(stationList)),
    setStation: station => dispatch(setStation(station)),
    mainBanner: () => dispatch(mainBannerSelectionStart()),
    smallBanner: () => dispatch(smallBannerSelectionStart()),
    menucategory: () => dispatch(menuCategorySelectionStart()),
    setStationFetching: value => (dispatch(setStationFetching(value))),
    setLeadTime: value => (dispatch(checkLeadTimeSuccess(value))),
    setStationToggle: () => dispatch(ToggleStationList()),
    ToggleEmptyPop: value => dispatch(ToggleEmptyCartPop(value)),
    setStationAll: () => dispatch(setStationsDetailAllStart()),
    setDate: date => dispatch(setBoardingDate(date)),
    setTrainNo: trainNo => dispatch(setTrainNo(trainNo)),
    setBoardingStation: station => dispatch(setBoardingStation(station)),
    setPnr: pnr => dispatch(setPnr(pnr)),
    setTab: tab => dispatch(setHomeTab(tab)),
    setUrlData: data => dispatch(setUrlData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(homePage);